module.exports = require('../dist/compat/array/uniqBy.js').uniqBy;
